import { createTheme } from "@mui/material/styles";
import type { PaletteMode } from "@mui/material";

export const getTheme = (mode: PaletteMode = "light") => {
  const isDark = mode === "dark";

  return createTheme({
    palette: {
      mode,
      text: {
        primary: "#313131",
        secondary: "#9443DF",
      },
      primary: {
        main: "#E4E8FF",
        contrastText: "#FFFFFF",
      },
      background: {
        paper: isDark ? "#1E1E1E" : "#FFFFFF",
        default: isDark ? "#121212" : "#FFFFFF",
      },
      success: {
        main: "#4CAF50",
        contrastText: "#FFFFFF",
      },
      error: {
        main: "#EF5350",
        contrastText: "#FFFFFF",
      },
    },

    // Custom (non-MUI) values moved here
    // If you need these values, export them separately below:

    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            // fontSize: "1.11vw",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#8155E1",
            },
          },
          input: {
            // fontSize: "1.11vw",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            // fontSize: "1.11vw",
            color: "#A5A5A5",
            "&.Mui-focused": {
              color: "#8155E1",
            },
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            "&::before": {
              backgroundColor: "transparent",
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          contained: {
            background: "linear-gradient(180deg, #9D79F4 0%, #7747FB 100%)",
            textTransform: "none",
            color: "#fff",
            "&:hover": {
              background: "linear-gradient(180deg, #8861F7 0%, #6333F9 100%)",
            },
            "&:focus": {
              outline: "none",
            },
          },
          outlined: {
            border: "1px solid #8155E1",
            background: "#F0DEFF",
            color: "#8155E1",
            textTransform: "none",
            "&:hover": {
              background: "rgba(129, 85, 225, 0.08)",
              border: "1px solid #8155E1",
              color: "#191919",
            },
            "&:focus": {
              outline: "none",
            },
          },
          text: {
            textTransform: "none",
            "&:focus": {
              outline: "none",
            },
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: "#000000",
            "&.Mui-checked": {
              color: "#9443DF",
            },
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.04)",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            outline: "none",
            "&:focus": {
              outline: "none",
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            fontSize: "1.11vw",
          },
          icon: {
            color: "#DBDBDB",
          },
        },
      },

      MuiRadio: {
        styleOverrides: {
          root: {
            color: "#9747FF",
            "&.Mui-checked": {
              color: "#9747FF",
            },
          },
        },
      },
      MuiBadge: {
        styleOverrides: {
          badge: {
            backgroundColor: "#ECE4C7",
            color: "#F7A86E",
            fontSize: "0.75rem", // Adjust based on need
          },
        },
      },
    },

    //     typography: {
    //   // fontFamily: "Nexa, Arial, sans-serif",
    //   fontFamily: "'Lato', sans-serif",
    //   fontWeightLight: 400,
    //   fontWeightRegular: 400,
    //   fontWeightMedium: 500,
    //   fontWeightBold: 700,
    //   h1: { fontFamily: "Lato", fontWeight: 700 },
    //   h2: { fontFamily: "Lato", fontWeight: 600 },
    //   h3: { fontFamily: "Lato", fontWeight: 500 },
    //   body1: { fontFamily: "Lato", fontWeight: 400 },
    //   body2: { fontFamily: "Lato", fontWeight: 400 },
    //   button: { fontFamily: "Lato", fontWeight: 600 },
    // },

    typography: {
      fontFamily: "'Lato','Inter', sans-serif",
      htmlFontSize: 16,
      h1: { fontWeight: 700, fontSize: "2.5rem", lineHeight: 1.2 },
      h2: { fontWeight: 700, fontSize: "2rem", lineHeight: 1.3 },
      h3: { fontWeight: 600, fontSize: "1.75rem", lineHeight: 1.4 },
      h4: { fontWeight: 600, fontSize: "1.5rem", lineHeight: 1.4 },
      h5: { fontWeight: 500, fontSize: "1.25rem", lineHeight: 1.5 },
      h6: { fontWeight: 500, fontSize: "1.125rem", lineHeight: 1.5 },
      subtitle1: { fontSize: "1rem", fontWeight: 400 },
      subtitle2: { fontSize: "0.875rem", fontWeight: 400 },
      body1: { fontSize: "1rem", fontWeight: 400 },
      body2: { fontSize: "0.875rem", fontWeight: 400 },
      button: {
        fontSize: "0.875rem",
        fontWeight: 600,
        textTransform: "uppercase",
      },
      caption: { fontSize: "0.75rem", fontWeight: 400 },
      overline: {
        fontSize: "0.75rem",
        fontWeight: 500,
        textTransform: "uppercase",
      },
    },
  });
};
